module.exports = __webpack_public_path__ + "static/media/31JFA8.36df73d8.jpg";